import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import React, { Component } from 'react';

import Svg from '../images/onboarding/empty-estate-processo.png';
import styled from '../styled-components';

export default class LiteOnboarding extends Component<PropType, StateType> {
  constructor(props) {
    super(props)

    this.state = {
      page: 0,
      content: [I18n.l('lite.process.createProcessDesc'), I18n.l('lite.process.createProcessDesc.two')],
    }
  }

  changePageHandler = () => {
    if (this.state.page === 0) {
      this.setState({ page: 1 })
    } else {
      localStorage.setItem('hasSeenOnboarding', 'true')
      this.props.onOnboardingSeen(true)
    }
  }

  returnHandler = () => {
    this.setState({ page: 0 })
  }

  setPageHandler = (index: number) => {
    return (e: any) => {
      this.setState({ page: index })
    }
  }


  render() {
    return (
      <Wrapper>
        <img className="icon" src={Svg}></img>
        <div className="click-trough">
          <h3>{I18n.l('lite.process.createProcess')}</h3>
          <p className="description-text">{this.state.content[this.state.page]}</p>
          <div className="flex-row">
            {this.state.content.map((text: any) => {
              if (this.state.page === this.state.content.indexOf(text)) {
                return <Icon key={this.state.content.indexOf(text)} className="status-button active" icon={faCircle} />
              } else {
                return <button className="invisibleButton" onClick={this.setPageHandler(this.state.content.indexOf(text))}><Icon key={this.state.content.indexOf(text)} className="status-button" icon={faCircle} /></button>
              }
            })}
          </div>
          <div className="flex-row center margin-top">
            {this.state.page === 1 && <a onClick={this.returnHandler} className="return-button">{I18n.l('common.back')}</a>}
            <button className="continue-button" onClick={this.changePageHandler}>Continuar</button>
          </div>
        </div>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
margin-top: -5%;

.icon{  
  width: 40%;
}


.click-trough{
    display: flex;
    flex-direction: column;
    align-items: center;

  h3{
    font-size: 2.5em;
    font-weight: 600;
  }
  p{
    font-size: 1.2em;
  }
  
  
  .continue-button{
    width: 10em;
    height: 3em;
    border: none;
    border-radius: 30px;
    color: white;
    background: #335D7C;
    margin-top: 5%;
  }

  .continue-button:hover{
    cursor: pointer;
  }

  .description-text{
    width: 40em;
    line-height: 1.5;
    text-align: center;
  }
  
  .flex-row{
    display: flex;
    flex-direction: row;
    align-items: center;

    .return-button{
      transform: translateY(0.4em);
      font-weight: 500;
      font-size: 1.2em;
      margin: 0 1.3em;
      color: #335D7C;
    }
  }

  .status-button{
    margin: 0 0.25em;
  }

  .active{
    color: #00857D;
    animation: size;
    animation-duration: 0.3s;
  }

  @keyframes size {
    from{
      width: 0.1em
    }
    to{
      width: 1em;
    }
  }
  
  .center{
    align-items: center;
  }
  .margin-top{
    margin-top: 0.5em;
  }

  .invisibleButton{
    border: none;
    margin: none;
    background: none;
  }
  
}
`
